import { SERVER_HOST } from '../config/server';

/**
 * Busca status do servidor via mcsrvstat.us (API pública).
 * @param {string} [host]
 * @returns {Promise<{
 *   online: boolean,
 *   playersOnline: number | null,
 *   playersMax: number | null,
 *   version: string | null,
 *   host: string,
 *   checkedAt: number,
 * }>}
 */
export async function fetchMinecraftStatus(host = SERVER_HOST) {
  const response = await fetch(`https://api.mcsrvstat.us/3/${encodeURIComponent(host)}`, {
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`Falha ao consultar status (${response.status})`);
  }

  const data = await response.json();

  return {
    online: Boolean(data.online),
    playersOnline: data.players?.online ?? null,
    playersMax: data.players?.max ?? null,
    version: data.version || data.protocol?.name || null,
    host,
    checkedAt: Date.now(),
  };
}
